import React from "react";
import { connect } from "react-redux";
import {injectIntl} from "react-intl";
import { withRouter } from "react-router-dom";

import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import SvgIcon from "@mui/material/SvgIcon";

import {LookCoBrowseIcon} from "../../../common/icons";
import COLOR_THEMES from "../../../../colorThemes";
import {setLookPageOpened} from "../../../../actions/lookFunctions";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import WithPingPilotCheck from "../../hocs/withPingPilotCheck";

const LookSideBarPingPilotButton = (props) => {

  const {intl, lookPageOpened, activeTheme, sidebarButtonClicked, popupCloseClick, disabled, pingButton} = props;

  const pingButtonClick = () => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookSidebarPingPilot);
    if (lookPageOpened && popupCloseClick) {
      popupCloseClick();
    } else {
      pingButton.click();
    }
    sidebarButtonClicked();
  }

  const realDisabled = disabled;

  return (
    <li className="look-sidebar__list-item ping-pilot-visualizer-button">
      <Tooltip title={intl.formatMessage({id:"tooltip.help"})} placement="right">
        <IconButton aria-label={intl.formatMessage({id:"tooltip.сameraViews"})}
                    disabled={realDisabled}
                    className="look-icon look-sidebar__button"
                    onClick={pingButtonClick}>
          <SvgIcon>
            <LookCoBrowseIcon color={realDisabled ? "rgba(0, 0, 0, 0.26)" : COLOR_THEMES[activeTheme].primary}/>
          </SvgIcon>
        </IconButton>
      </Tooltip>
    </li>
  )
};

const mapStateToProps = (store) => {
  const {activeTheme, visualizersLoaded} = store.serverState;
  const {lookPageOpened} = store.lookState;
  return {
    activeTheme,
    lookPageOpened,
    visualizersLoadedLength: visualizersLoaded.length
  };
};

const mapDispatchToProps = {
  setLookPageOpened,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(WithPingPilotCheck(LookSideBarPingPilotButton))
  )
)
